
export default async function getBikeSharingStations() {
  return fetch('https://bikes.peerigon.io').then(res => res.json());
}



// WEBPACK FOOTER //
// ./src/lib/getBikeSharingStations.ts